export const ACP_RELEASE_VERSION = '26.4';
export const ACP_SATOS_VERSION = '2.0.9.3';